var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.743 16.751a1.659 1.659 0 00-2.466-.34l-4.003 3.079a2.486 2.486 0 01.226 1.028 2.513 2.513 0 01-2.51 2.51h-5.03a.5.5 0 010-1h5.03a1.51 1.51 0 00.008-3.02h-12.2a2.852 2.852 0 00-1.95.83s-3.25 3.439-4.576 4.853a.998.998 0 00.026 1.39l2.64 2.64a.997.997 0 001.378.03l1.61-1.507a.984.984 0 01.731-.236H19.04a4.671 4.671 0 001.909-.436c2.555-1.017 6.664-4.694 8.75-7.95a1.713 1.713 0 00.045-1.87zm-14.243.257l.191-.243A10.824 10.824 0 0018 10.01a10.823 10.823 0 00-2.308-6.758l-.19-.243-.192.243A10.816 10.816 0 0013 10.008a10.82 10.82 0 002.31 6.757zm1.764-.417l-.264.417.48-.11a8.436 8.436 0 006.488-7.363l.024-.246-.246.025a8.333 8.333 0 00-4.752 2.115h-.001a10.619 10.619 0 01-1.719 5.147z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--sustainability-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'SustainabilityIcon';
export default Icon;